import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouseMerchantShipSettingsV2Response as SchemaDeliveryWarehouseMerchantShipSettingsV2Response } from '../schemas/DeliveryWarehouseMerchantShipSettingsV2Response';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDeliveryWarehouseMerchantShipSettingsV2ContentType = '' as const;
export type GetDeliveryWarehouseMerchantShipSettingsV2Request = void;
export type GetDeliveryWarehouseMerchantShipSettingsV2Responses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaDeliveryWarehouseMerchantShipSettingsV2Response;
    };
};
export type GetDeliveryWarehouseMerchantShipSettingsV2ResponseSuccess =
    GetDeliveryWarehouseMerchantShipSettingsV2Responses['200']['application/json'];
export type GetDeliveryWarehouseMerchantShipSettingsV2SearchParams = undefined;
export type GetDeliveryWarehouseMerchantShipSettingsV2PathParameters = {
    warehouse_id: string;
};
export const GetDeliveryWarehouseMerchantShipSettingsV2Url =
    '/delivery/warehouse/{warehouse_id}/settings/merchant-ship' as const;
export const GetDeliveryWarehouseMerchantShipSettingsV2Method = 'GET' as const;
export const getGetDeliveryWarehouseMerchantShipSettingsV2Url = (
    params: GetDeliveryWarehouseMerchantShipSettingsV2PathParameters
) =>
    GetDeliveryWarehouseMerchantShipSettingsV2Url.replace(
        /\{(\w+)\}/g,
        (_match, param: keyof GetDeliveryWarehouseMerchantShipSettingsV2PathParameters) => String(params[param])
    );
